<template>
    <DsDialog
        v-model:open="isOpen"
        :primaryLoading="isFetching"
        primaryLabel="Yes"
        secondaryLabel="Close"
        title="Deactivate account"
        @clickPrimary="submitDeactivateRequest()"
        @clickSecondary="isOpen = false"
    >
        <p class="text-content-lg">Are you sure you want to deactivate {{ name }}?</p>
        <p class="mt-2 text-content-md text-content-error">To reactivate, please contact the technology team.</p>
    </DsDialog>
</template>

<script setup lang="ts">
import { toastOnUseFetchResponse } from '@/shared/utils/toastr';
import DsDialog from '@ds/DsDialog.vue';
import { useFetch } from '@vueuse/core';
import type { AccountApiResponse } from './Account.types';

const props = defineProps<Pick<AccountApiResponse['account'], 'id' | 'name'>>();

const isOpen = defineModel<boolean>({ default: false });
const emit = defineEmits<{ deactivated: [id: AccountApiResponse['account']['id']] }>();

const {
    execute: submitDeactivateRequest,
    onFetchResponse: onDeactivateSuccess,
    isFetching,
} = useFetch(`/api/accounts/${props.id}/deactivate`, {
    immediate: false,
    afterFetch: toastOnUseFetchResponse,
})
    .patch()
    .json();

onDeactivateSuccess(() => {
    isOpen.value = false;
    emit('deactivated', props.id);
});
</script>
